import { WAREHOUSES_LIMITS_UP_TO_DAY } from '@/pages/supplies-management/children/warehouses-limits/page/_components/connected-warehouses-limits/_constants';
import { TPartOfCoefficientReport } from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module/types';
import { TPartialCoefficientsReportItem } from '../types';

type TProps = {
  warehousesData?: TPartialCoefficientsReportItem;
  selectedDate: Date | null;
};

/*
 хелпер для получения наибольшего списка дат данных или же если их нет, или их
 недостаточно, то рисовать фейковые на шаг вперед
 */
export const getLargestDataOfDates = ({
  warehousesData,
  selectedDate,
}: TProps): TPartOfCoefficientReport => {
  let data = [];
  warehousesData?.forEach((el) => {
    Object.values(el).forEach((warehousesType) => {
      if (warehousesType.length > data.length) {
        data = warehousesType;
      }
    });
  });

  if (!data.length) {
    const date = selectedDate || new Date();
    data.push({
      date: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
      ).toISOString(),
      coefficient: -1,
    });
  }

  // при недостатке данных по датам, что бы отображение было целостным за WAREHOUSES_LIMITS_UP_TO_DAY дней
  while (data.length < WAREHOUSES_LIMITS_UP_TO_DAY) {
    const lastDataDate = new Date(data.at(-1).date);
    data.push({
      date: new Date(
        lastDataDate.getFullYear(),
        lastDataDate.getMonth(),
        lastDataDate.getDate() + 1,
      ).toISOString(),
      coefficient: -1,
    });
  }

  return data;
};
